'use strict'

import React from 'react'
import { Link } from 'react-router'
import $ from 'jquery'

require('styles/IndexList.less')

class IndexList extends React.Component {
  constructor(props) {
    super(props)
    this.selectIndexClose = this.selectIndexClose.bind(this)
  }
  componentDidMount() {
  }
  over(e) {
    $(e.target).closest('li').addClass('over')
  }
  out(e) {
    $(e.target).closest('li').removeClass('over')
  }
  selectIndexClose()
  {
    const { actions } = this.props;
    actions.indexClose()
    $(window).scrollTop(0)
  }
  render() {
    var { posts, cat } = this.props
    var self = this
    if (posts == null) {
      return (<div/>)
    }
    return (
      <div className='indexlist'>
        { posts ?
          <ul className='inner'>
          { posts.map(function(post, i) {
            return (
                <li key={i}>
                  <div className='info'>
                    <h2 className='title'>
                      <Link to={'/' + post.slug} onMouseEnter={this.over} onMouseLeave={this.out} onClick={self.selectIndexClose}>
                        <span>{ post.title.rendered }</span>
                      </Link>
                    </h2>
                    <p className='date'>
                    { post.acf.original_date ?
                      <Link to={'/' + post.slug} onMouseEnter={this.over} onMouseLeave={this.out} onClick={self.selectIndexClose}>
                        <span>{ post.acf.original_date }</span>
                      </Link>
                    :null }
                    </p>
                    <div className='cat'>
                      { cat.map(function(c, i) {
                        return (
                          <div className='inner' key={i}>
                            { post.categories[0] == c.id ? c.name:null }
                          </div>
                        )
                      })}
                    </div>
                  </div>
                  {post.acf.thumbnail ?
                  <div className='image'>
                    <Link to={'/' + post.slug} onMouseEnter={this.over} onMouseLeave={this.out} onClick={self.selectIndexClose}>
                      <img src={post.acf.thumbnail} />
                    </Link>
                  </div>
                  :null}
                </li>
              )
            }.bind(this))
          }
          </ul>
        :
          <ul className='inner'><li></li></ul>
        }
      </div>
    )
  }
}

IndexList.displayName = 'IndexList'

IndexList.propTypes = {}
IndexList.defaultProps = {}

export default IndexList



// WEBPACK FOOTER //
// ./src/components/IndexListComponent.js